import React from "react";

const BackButton = ({ onClick, label = "Back" }) => {
  return (
    <button
      className="flex items-center gap-2 text-gray-800 font-medium mb-8"
      onClick={onClick}
    >
      <span className="text-xl">←</span> {label}
    </button>
  );
};

export default BackButton;